export default __webpack_public_path__ + "static/media/467951__benzix2__ui-button-click.518aa924.mp3";